import {
	gsap
} from "gsap/dist/gsap";
import {
	ScrollTrigger
} from "gsap/dist/ScrollTrigger";
import {
	ScrollToPlugin
} from "gsap/dist/ScrollToPlugin";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
let mainContent = document.getElementById('site');
var preLoaderEl = document.querySelector('.preloader');
const headerBar = mainContent.querySelector('#masthead');
var headerBarAnimate = gsap.timeline({
	paused: true, // default is false
	smoothChildTiming: true,
});
headerBarAnimate
	.fromTo(
		headerBar, {
			opacity: 0,
			scale: 0.95
		}, {
			opacity: 1,
			scale: 1,
			ease: "power3.in",
			duration: 1
		},
	)
let titlePagesAnimate = gsap.timeline({
	paused: true, // default is false
	defaults: { // children inherit these defaults
		duration: 1.2,
		ease: "power2.out"
	},
	smoothChildTiming: true,
});
titlePagesAnimate
.fromTo('.sub-page-title',
 {
	scale: 1.2,
	opacity: 0,
	duration: 1.2
}, {
	scale: 1,
	opacity: 1,
})
.fromTo( '.custom-title-desc',
	{
		scale: 1.2,
		opacity: 0,
		duration: 1.2
	}, {
		scale: 1,
		opacity: 1,
	},
	'<.15'
)
let timelineHeroContent = gsap.timeline({
	paused: true, // default is false
	defaults: { // children inherit these defaults
		duration: 1,
		ease: "power2.out"
	},
})
timelineHeroContent.fromTo('.our-service-card', {
	opacity: 0,
	duration: 1,
	scale: 1.2,
}, {
	opacity: 1,
	scale: 1,
	stagger: 0.1
})
let timelineExpertise = gsap.timeline({
	scrollTrigger: {
		trigger: '.expertise-wrapper',
		start: "top center",
		end: 'bottom bottom',
	},
	paused: false, // default is false
	defaults: { // children inherit these defaults
		duration: 1.8,
		ease: "power2.out"
	},
})
timelineExpertise
	.fromTo("div h2", {
		opacity: 0,
		scale: 1.2
	}, {
		opacity: 1,
		scale: 1
	});
var cards = document.querySelectorAll('.content-with-image');
cards.forEach(function (card) {
	var titleExpertise = card.querySelectorAll('.titleExpertise-content');
	var imageExpertise = card.querySelectorAll('.imageExpertise');
	var textExpertise = card.querySelectorAll('.descExpertise-content');
	var buttonExpertise = card.querySelectorAll('.btn-contact-us');
	var cardAnimation = gsap.timeline({
		scrollTrigger: {
			trigger: card,
			start: "top center",
		},
		defaults: {
			duration: 1,
			ease: "power2.out"
		}
	});
	cardAnimation.fromTo(titleExpertise, {
		opacity: 0,
		scale: 1.2
	}, {
		opacity: 1,
		scale: 1
	}, "<.1");
	cardAnimation.fromTo(imageExpertise, {
		opacity: 0,
		y: '30px'
	}, {
		opacity: 1,
		y: '0px'
	}, "<.1");
	cardAnimation.fromTo(textExpertise, {
		opacity: 0,
		scale: 1.2
	}, {
		opacity: 1,
		scale: 1
	}, "<.1");
	cardAnimation.fromTo(buttonExpertise, {
		y: '50px',
		opacity: 0
	}, {
		y: '0px',
		opacity: 1,
	}, "<.1");
});
let timelineOurtools = gsap.timeline({
	scrollTrigger: {
		trigger: '.our-tools-wrapper',
		start: "top center",
		end: "bottom center",
	},
	paused: false, // default is false
	defaults: { // children inherit these defaults
		duration: 1.8,
		ease: "power2.out"
	},
})
timelineOurtools
	.fromTo(".our-tools", {
		opacity: 0,
		scale: 1.2
	}, {
		opacity: 1,
		scale: 1
	})
	.fromTo(".tool", {
		y: '40px',
		opacity: 0,

	}, {
		y: '0px',
		opacity: 1,
		stagger: 0.2
	}, '<.2');
var timelineFeaturedWorks = gsap.timeline({
	scrollTrigger: {
		trigger: '.feature-work-lists',
		start: 'top 80%',
	},
});
timelineFeaturedWorks
	.fromTo('.feature-work-lists .section-title', {
		scale: 1.2,
		opacity: 0
	}, {
		opacity: 1,
		scale: 1,
		duration: 1
	})
	.fromTo('.our-work__portofolio figure', {
		width: '75%',
		duration: 1,

	}, {
		width: '100%',
		stagger: .2
	}, '<.1')
	.fromTo('.our-work__portofolio figure img', {
		scale: 1.2
	}, {
		duration: 1,
		scale: 1,
		stagger: .2
	}, '-=1');

// js discover
var timelineLikes = gsap.timeline({
    scrollTrigger: {
        trigger: '.discover-us-on-dribbble-wrapper',
        start: 'top 80%',
    },
});
timelineLikes
    .fromTo('.discover-us-on-dribbble-wrapper .section-title', {
        scale: 1.2,
        opacity: 0
    }, {
        opacity: 1,
        scale: 1,
        duration: 1
    })
    .fromTo('.discoverSlider', {
        opacity: 0,
        scale: 1.15,
    }, {
        opacity: 1,
        scale: 1,
        duration: 1
    }, '<.2');
// js discover dribble
// Animasi untuk elemen dengan id '#views'
var timelineViews = gsap.timeline({
    scrollTrigger: {
        trigger: '.discover-us-on-dribbble-wrapper',
        start: 'top 80%',
    },
});
gsap.utils.toArray('#views').forEach(function (el) {
    var target = {
        val: 0
    };
    timelineViews.to(target, {
        val: el.getAttribute('data-number'),
        duration: 1.5,
        onUpdate: function () {
            el.innerText = target.val.toFixed(0);
        },
    });
});
// Animasi untuk elemen dengan id '#likes'
var timelineLikes = gsap.timeline({
    scrollTrigger: {
        trigger: '.discover-us-on-dribbble-wrapper',
        start: 'top 80%',
    },
});
gsap.utils.toArray('#likes').forEach(function (el) {
    var target = {
        val: 0
    };
    timelineLikes.to(target, {
        val: el.getAttribute('data-number'),
        duration: 1.5,
        onUpdate: function () {
            el.innerText = target.val.toFixed(0);
        },
    });
});
// Animasi untuk elemen dengan id '#followers'
var timelineFollowers = gsap.timeline({
    scrollTrigger: {
        trigger: '.discover-us-on-dribbble-wrapper',
        start: 'top 80%',
    },
});
gsap.utils.toArray('#followers').forEach(function (el) {
    var target = {
        val: 0
    };
    timelineFollowers.to(target, {
        val: el.getAttribute('data-number'),
        duration: 1.5,
        onUpdate: function () {
            el.innerText = target.val.toFixed(0);
        },
    });
});
// about section
var timelineSatisfied = gsap.timeline({
    scrollTrigger: {
        trigger: 'discover-us-on-dribbble-wrapper .section-title',
        start: 'top bottom',
    },
});
timelineSatisfied
    .fromTo('discover-us-on-dribbble-wrapper .section-title', {
        scale: 1.2,
        opacity: 0
    }, {
        opacity: 1,
        scale: 1,
        duration: 1,
		stagger:.1
    })
    .fromTo('.img-illustrator', {
        opacity: 0,
        scale: 1.1
    }, {
        opacity: 1,
        scale: 1,
        duration: 1.5
    }, '<.1')
gsap.utils.toArray('#likes').forEach(function (el) {
	var target = {
		val: 0
	};
	timelineLikes.to(target, {
		val: el.getAttribute('data-number'),
		duration: 2,
		onUpdate: function () {
			el.innerText = target.val.toFixed(0);
		},
	});
});
// Timeline untuk elemen dengan id 'followers'
var timelineFollowers = gsap.timeline({
	scrollTrigger: {
		trigger: '.discover-us-on-dribbble-wrapper',
		start: 'top 80%',
		toggleActions: 'restart pause resume pause',
	},
});
gsap.utils.toArray('#followers').forEach(function (el) {
	var target = {
		val: 0
	};
	timelineFollowers.to(target, {
		val: el.getAttribute('data-number'),
		duration: 2,
		onUpdate: function () {
			el.innerText = target.val.toFixed(0);
		},
	});
});
let timelineOtherService = gsap.timeline({
	scrollTrigger: '.other-services',
	start: "top center",
	paused: false, // default is false
	defaults: { // children inherit these defaults
		duration: 1,
		ease: "power2.out"
	},
});
timelineOtherService
	.fromTo(".card-service", {
		y: '40px',
		opacity: 0,

	}, {
		y: '0px',
		opacity: 1,
		stagger: 0.2
	}, '<.2')
document.addEventListener("DOMContentLoaded", function () {
	if (preLoaderEl) {
		setTimeout(function () {
			preLoaderEl.classList.add('hide');
			mainContent.classList.remove('overflow-hidden');
			mainContent.classList.remove('opacity-0');
			mainContent.classList.add('opacity-100');
			window.scroll({
				top: 0,
				left: 0,
				behavior: 'smooth'
			});
			headerBarAnimate.play();
		}, 1300);
	}
	setTimeout(function(){
		titlePagesAnimate.play();
		timelineHeroContent.play();
	}, 2000);
});
